'use client'

import {Area, AreaChart, XAxis} from "recharts";
import {ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent} from "@/components/ui/chart";

const chartConfig = {
  value: {
    label: "Value",
    color: "var(--chart-1)",
  }
} satisfies ChartConfig


export default function CardChart({ chartData }: { chartData: any }){
  return (
    <ChartContainer config={chartConfig} className="h-24 w-full">
      <AreaChart
        accessibilityLayer
        data={chartData}
        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
      >
        <defs>
          <linearGradient id="fillValue" x1="0" y1="0" x2="0" y2="1">
            <stop
              offset="5%"
              stopColor="var(--color-value)"
              stopOpacity={0.8}
            />
            <stop
              offset="95%"
              stopColor="var(--color-value)"
              stopOpacity={0.1}
            />
          </linearGradient>
        </defs>
        <Area type="monotone" dataKey="value" stroke="var(--color-value)" fillOpacity={0.4} fill="url(#fillValue)" />
        <ChartTooltip
          cursor={false}
          content={<ChartTooltipContent hideIndicator />}
        />
        <XAxis dataKey="date" hide />
      </AreaChart>
    </ChartContainer>
  )
}
